import {
  PossibleLocationsOrAll,
  StepsAny,
  StoreModuleStatus,
  isStepsAny,
} from "../../../constants";
import { isValidStep } from "../../../utils";
import { JsonFormControl, JsonFormSelectOption } from "../../JsonForm";
import { Steps2S } from "./controls.2s";
import { StepsPS } from "./controls.ps";
import { Steps2SAux } from "./controls.2s";
import { StepsPSAux } from "./controls.ps";

/**
 * Helper function that gets a JsonFormControl for the correct step on deck.
 * TODO: Refactor this to fetch step from a map.
 * @param {string} stepName Name of the step to be performed.
 * @returns {JsonFormControl[]}
 */
export function getFormControl(
  stepName: string,
  store: StoreModuleStatus,
  stepLocation?: PossibleLocationsOrAll,
): JsonFormControl[] {
  const invalidStepError = new TypeError(`Invalid step ${stepName}`);
  if (!isValidStep(stepName)) throw invalidStepError;
  let step: JsonFormControl[] | undefined = undefined;
  if (stepName.startsWith("2S_")) {
    step = Steps2S[stepName.slice(3)];
  } else if (stepName.startsWith("PS_")) {
    step = StepsPS[stepName.slice(3)];
  } else if (stepName.startsWith("AUX_2S_")) {
    step = Steps2SAux[stepName];
  } else if (stepName.startsWith("AUX_PS_")) {
    step = StepsPSAux[stepName];
  }
  if (!step) throw invalidStepError;
  return isStepsAny(stepName)
    ? transformSerialControls(step, stepName, store, stepLocation)
    : step;
}

export function transformSerialControls(
  formElements: JsonFormControl[],
  stepName: StepsAny,
  store: StoreModuleStatus,
  stepLocation?: PossibleLocationsOrAll,
) {
  if (!store) return formElements;
  return formElements.map((formElement) => {
    if (
      formElement.controlConfigs &&
      formElement.controlConfigs.serialNumberType
    ) {
      const serialNumberType = formElement.controlConfigs.serialNumberType;
      let filteredPartsList = store.partsByType[serialNumberType] ?? [];
      if (stepLocation && stepLocation !== "All") {
        const validPartsByLocation = store.partsByLocation[stepLocation] ?? [];
        filteredPartsList = filteredPartsList.filter((sn) =>
          validPartsByLocation.includes(sn),
        );
      }
      // For Aux parts, only validate location and type.
      if (serialNumberType.startsWith("Aux.")) {
        return {
          ...formElement,
          options: formatSnListAsSelectOpts(filteredPartsList),
        };
      }
      // For all other parts, also validate step requirements.
      let cStepName = stepName;
      if (serialNumberType.startsWith("2S.SEH")) {
        stepName.startsWith("AUX") ? (cStepName = "2S_GLUE_HYBRID") : stepName;
      }
      if (serialNumberType.startsWith("PS.ROH")) {
        stepName.startsWith("AUX")
          ? (cStepName = "PS_SANDWICH_HYBRID_GLUING")
          : stepName;
      }

      if (
        (serialNumberType.startsWith("2S.Module") ||
          serialNumberType.startsWith("PS.Module")) &&
        stepName.startsWith("AUX") &&
        store.incompleteModules &&
        stepLocation &&
        stepLocation !== "All"
      ) {
        const validIncompleteModules =
          store.incompleteModules[stepLocation] ?? [];
        filteredPartsList = filteredPartsList.filter((sn) =>
          validIncompleteModules.includes(sn),
        );
      } else if (
        formElement.filterIncomplete &&
        stepLocation &&
        stepLocation !== "All"
      ) {
        // Bypass step filtering, only filter by incomplete modules
        const validIncompleteModules =
          store.incompleteModules?.[stepLocation] ?? [];
        filteredPartsList = filteredPartsList.filter((sn) =>
          validIncompleteModules.includes(sn),
        );
      } else {
        const validPartsAtStep = store.modulesForStep[cStepName] ?? [];
        const badModules = store.badModules ?? [];
        filteredPartsList = filteredPartsList
          .filter((sn) => validPartsAtStep.includes(sn))
          .filter((sn) => !badModules.includes(sn));
      }

      /*

      if (
        (serialNumberType.startsWith("2S.Module") ||
          serialNumberType.startsWith("PS.Module")) &&
        stepName.startsWith("AUX") &&
        store.incompleteModules &&
        stepLocation &&
        stepLocation !== "All"
      ) {
        const validIncompleteModules =
          store.incompleteModules[stepLocation] ?? [];
        filteredPartsList = filteredPartsList.filter((sn) =>
          validIncompleteModules.includes(sn),
        );
      } else {
        const validPartsAtStep = store.modulesForStep[cStepName] ?? [];
        const badModules = store.badModules ?? [];
        filteredPartsList = filteredPartsList
          .filter((sn) => validPartsAtStep.includes(sn))
          .filter((sn) => !badModules.includes(sn));
      }
*/
      return {
        ...formElement,
        options: formatSnListAsSelectOpts(filteredPartsList),
      };
    }
    return formElement;
  });
}

function formatSnListAsSelectOpts(sns: string[]): JsonFormSelectOption[] {
  return sns.map((sn) => ({ label: sn, value: sn }));
}

export { Steps2S, StepsPS };
